import PropTypes from 'prop-types';

import TextInput from '#globalComponents/Forms/TextInput';

export const RangeInputFilter = ({
	fromId,
	toId,
	fromValue,
	toValue,
	onFromChange,
	onToChange,
	fromPlaceholder = 'Min',
	toPlaceholder = 'Max',
	unit,
	type = 'number',
	step,
	min,
	max,
}) => {
	const clampOnBlur = (rawValue, onChange) => {
		if (rawValue === '' || rawValue === undefined) return;
		let num = parseFloat(rawValue);
		if (isNaN(num)) {
			onChange('');
			return;
		}
		if (min !== undefined && num < min) num = min;
		if (max !== undefined && num > max) num = max;
		// Preserve the step precision (e.g. 0.1 → one decimal)
		if (step && step < 1) {
			const decimals = String(step).split('.')[1]?.length || 0;
			num = parseFloat(num.toFixed(decimals));
		} else if (Number.isInteger(step)) {
			num = Math.round(num);
		}
		onChange(String(num));
	};

	return (
		<div className="flex items-center gap-2">
			<div className="flex-1">
				<div className="relative">
					<TextInput
						type={type}
						id={fromId}
						placeholder={fromPlaceholder}
						value={fromValue || ''}
						onChange={(e) => onFromChange(e.target.value)}
						onBlur={() => clampOnBlur(fromValue, onFromChange)}
						step={step}
						min={min}
						max={max}
					/>
					{unit && fromValue && (
						<span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-bgBase-800 pointer-events-none">
							{unit}
						</span>
					)}
				</div>
			</div>
			<span className="text-bgBase-800 text-xs">–</span>
			<div className="flex-1">
				<div className="relative">
					<TextInput
						type={type}
						id={toId}
						placeholder={toPlaceholder}
						value={toValue || ''}
						onChange={(e) => onToChange(e.target.value)}
						onBlur={() => clampOnBlur(toValue, onToChange)}
						step={step}
						min={min}
						max={max}
					/>
					{unit && toValue && (
						<span className="absolute right-2 top-1/2 -translate-y-1/2 text-xs text-bgBase-800 pointer-events-none">
							{unit}
						</span>
					)}
				</div>
			</div>
		</div>
	);
};

RangeInputFilter.propTypes = {
	fromId: PropTypes.string.isRequired,
	toId: PropTypes.string.isRequired,
	fromValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	toValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onFromChange: PropTypes.func.isRequired,
	onToChange: PropTypes.func.isRequired,
	fromPlaceholder: PropTypes.string,
	toPlaceholder: PropTypes.string,
	unit: PropTypes.string,
	type: PropTypes.string,
	step: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	min: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	max: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
